// CountryFlag.js - Fixed version
const countryBoundaryMap = {
    "ZWE": "/countries_boundaries/ZWE.png",
    "Zimbabwe": "/countries_boundaries/Zimbabwe.png",
    "ZWE_white": "/countries_boundaries/ZWE_white.png",
    "Zimbabwe_white": "/countries_boundaries/Zimbabwe_white.png",
    "ZWE_blue": "/countries_boundaries/ZWE_blue.png",
    "Zimbabwe_blue": "/countries_boundaries/Zimbabwe_blue.png",
    "ZMB": "/countries_boundaries/ZMB.png",
    "Zambia": "/countries_boundaries/Zambia.png",
    "ZMB_white": "/countries_boundaries/ZMB_white.png",
    "Zambia_white": "/countries_boundaries/Zambia_white.png",
    "ZMB_blue": "/countries_boundaries/ZMB_blue.png",
    "Zambia_blue": "/countries_boundaries/Zambia_blue.png",
    "YEM": "/countries_boundaries/YEM.png",
    "Yemen": "/countries_boundaries/Yemen.png",
    "YEM_white": "/countries_boundaries/YEM_white.png",
    "Yemen_white": "/countries_boundaries/Yemen_white.png",
    "YEM_blue": "/countries_boundaries/YEM_blue.png",
    "Yemen_blue": "/countries_boundaries/Yemen_blue.png",
    "VNM": "/countries_boundaries/VNM.png",
    "Vietnam": "/countries_boundaries/Vietnam.png",
    "VNM_white": "/countries_boundaries/VNM_white.png",
    "Vietnam_white": "/countries_boundaries/Vietnam_white.png",
    "VNM_blue": "/countries_boundaries/VNM_blue.png",
    "Vietnam_blue": "/countries_boundaries/Vietnam_blue.png",
    "VEN": "/countries_boundaries/VEN.png",
    "Venezuela": "/countries_boundaries/Venezuela.png",
    "VEN_white": "/countries_boundaries/VEN_white.png",
    "Venezuela_white": "/countries_boundaries/Venezuela_white.png",
    "VEN_blue": "/countries_boundaries/VEN_blue.png",
    "Venezuela_blue": "/countries_boundaries/Venezuela_blue.png",
    "VAT": "/countries_boundaries/VAT.png",
    "Vatican City": "/countries_boundaries/Vatican City.png",
    "VAT_white": "/countries_boundaries/VAT_white.png",
    "Vatican City_white": "/countries_boundaries/Vatican City_white.png",
    "VAT_blue": "/countries_boundaries/VAT_blue.png",
    "Vatican City_blue": "/countries_boundaries/Vatican City_blue.png",
    "VUT": "/countries_boundaries/VUT.png",
    "Vanuatu": "/countries_boundaries/Vanuatu.png",
    "VUT_white": "/countries_boundaries/VUT_white.png",
    "Vanuatu_white": "/countries_boundaries/Vanuatu_white.png",
    "VUT_blue": "/countries_boundaries/VUT_blue.png",
    "Vanuatu_blue": "/countries_boundaries/Vanuatu_blue.png",
    "UZB": "/countries_boundaries/UZB.png",
    "Uzbekistan": "/countries_boundaries/Uzbekistan.png",
    "UZB_white": "/countries_boundaries/UZB_white.png",
    "Uzbekistan_white": "/countries_boundaries/Uzbekistan_white.png",
    "UZB_blue": "/countries_boundaries/UZB_blue.png",
    "Uzbekistan_blue": "/countries_boundaries/Uzbekistan_blue.png",
    "URY": "/countries_boundaries/URY.png",
    "Uruguay": "/countries_boundaries/Uruguay.png",
    "URY_white": "/countries_boundaries/URY_white.png",
    "Uruguay_white": "/countries_boundaries/Uruguay_white.png",
    "URY_blue": "/countries_boundaries/URY_blue.png",
    "Uruguay_blue": "/countries_boundaries/Uruguay_blue.png",
    "FSM": "/countries_boundaries/FSM.png",
    "Federated States of Micronesia": "/countries_boundaries/Federated States of Micronesia.png",
    "FSM_white": "/countries_boundaries/FSM_white.png",
    "Federated States of Micronesia_white": "/countries_boundaries/Federated States of Micronesia_white.png",
    "FSM_blue": "/countries_boundaries/FSM_blue.png",
    "Federated States of Micronesia_blue": "/countries_boundaries/Federated States of Micronesia_blue.png",
    "MHL": "/countries_boundaries/MHL.png",
    "Marshall Islands": "/countries_boundaries/Marshall Islands.png",
    "MHL_white": "/countries_boundaries/MHL_white.png",
    "Marshall Islands_white": "/countries_boundaries/Marshall Islands_white.png",
    "MHL_blue": "/countries_boundaries/MHL_blue.png",
    "Marshall Islands_blue": "/countries_boundaries/Marshall Islands_blue.png",
    "MNP": "/countries_boundaries/MNP.png",
    "Northern Mariana Islands": "/countries_boundaries/Northern Mariana Islands.png",
    "MNP_white": "/countries_boundaries/MNP_white.png",
    "Northern Mariana Islands_white": "/countries_boundaries/Northern Mariana Islands_white.png",
    "MNP_blue": "/countries_boundaries/MNP_blue.png",
    "Northern Mariana Islands_blue": "/countries_boundaries/Northern Mariana Islands_blue.png",
    "VIR": "/countries_boundaries/VIR.png",
    "United States Virgin Islands": "/countries_boundaries/United States Virgin Islands.png",
    "VIR_white": "/countries_boundaries/VIR_white.png",
    "United States Virgin Islands_white": "/countries_boundaries/United States Virgin Islands_white.png",
    "VIR_blue": "/countries_boundaries/VIR_blue.png",
    "United States Virgin Islands_blue": "/countries_boundaries/United States Virgin Islands_blue.png",
    "GUM": "/countries_boundaries/GUM.png",
    "Guam": "/countries_boundaries/Guam.png",
    "GUM_white": "/countries_boundaries/GUM_white.png",
    "Guam_white": "/countries_boundaries/Guam_white.png",
    "GUM_blue": "/countries_boundaries/GUM_blue.png",
    "Guam_blue": "/countries_boundaries/Guam_blue.png",
    "ASM": "/countries_boundaries/ASM.png",
    "American Samoa": "/countries_boundaries/American Samoa.png",
    "ASM_white": "/countries_boundaries/ASM_white.png",
    "American Samoa_white": "/countries_boundaries/American Samoa_white.png",
    "ASM_blue": "/countries_boundaries/ASM_blue.png",
    "American Samoa_blue": "/countries_boundaries/American Samoa_blue.png",
    "PRI": "/countries_boundaries/PRI.png",
    "Puerto Rico": "/countries_boundaries/Puerto Rico.png",
    "PRI_white": "/countries_boundaries/PRI_white.png",
    "Puerto Rico_white": "/countries_boundaries/Puerto Rico_white.png",
    "PRI_blue": "/countries_boundaries/PRI_blue.png",
    "Puerto Rico_blue": "/countries_boundaries/Puerto Rico_blue.png",
    "USA": "/countries_boundaries/USA.png",
    "United States of America": "/countries_boundaries/United States of America.png",
    "USA_white": "/countries_boundaries/USA_white.png",
    "United States of America_white": "/countries_boundaries/United States of America_white.png",
    "USA_blue": "/countries_boundaries/USA_blue.png",
    "United States of America_blue": "/countries_boundaries/United States of America_blue.png",
    "SGS": "/countries_boundaries/SGS.png",
    "South Georgia and the South Sandwich Islands": "/countries_boundaries/South Georgia and the South Sandwich Islands.png",
    "SGS_white": "/countries_boundaries/SGS_white.png",
    "South Georgia and the South Sandwich Islands_white": "/countries_boundaries/South Georgia and the South Sandwich Islands_white.png",
    "SGS_blue": "/countries_boundaries/SGS_blue.png",
    "South Georgia and the South Sandwich Islands_blue": "/countries_boundaries/South Georgia and the South Sandwich Islands_blue.png",
    "IOT": "/countries_boundaries/IOT.png",
    "British Indian Ocean Territory": "/countries_boundaries/British Indian Ocean Territory.png",
    "IOT_white": "/countries_boundaries/IOT_white.png",
    "British Indian Ocean Territory_white": "/countries_boundaries/British Indian Ocean Territory_white.png",
    "IOT_blue": "/countries_boundaries/IOT_blue.png",
    "British Indian Ocean Territory_blue": "/countries_boundaries/British Indian Ocean Territory_blue.png",
    "SHN": "/countries_boundaries/SHN.png",
    "Saint Helena": "/countries_boundaries/Saint Helena.png",
    "SHN_white": "/countries_boundaries/SHN_white.png",
    "Saint Helena_white": "/countries_boundaries/Saint Helena_white.png",
    "SHN_blue": "/countries_boundaries/SHN_blue.png",
    "Saint Helena_blue": "/countries_boundaries/Saint Helena_blue.png",
    "PCN": "/countries_boundaries/PCN.png",
    "Pitcairn Islands": "/countries_boundaries/Pitcairn Islands.png",
    "PCN_white": "/countries_boundaries/PCN_white.png",
    "Pitcairn Islands_white": "/countries_boundaries/Pitcairn Islands_white.png",
    "PCN_blue": "/countries_boundaries/PCN_blue.png",
    "Pitcairn Islands_blue": "/countries_boundaries/Pitcairn Islands_blue.png",
    "AIA": "/countries_boundaries/AIA.png",
    "Anguilla": "/countries_boundaries/Anguilla.png",
    "AIA_white": "/countries_boundaries/AIA_white.png",
    "Anguilla_white": "/countries_boundaries/Anguilla_white.png",
    "AIA_blue": "/countries_boundaries/AIA_blue.png",
    "Anguilla_blue": "/countries_boundaries/Anguilla_blue.png",
    "FLK": "/countries_boundaries/FLK.png",
    "Falkland Islands": "/countries_boundaries/Falkland Islands.png",
    "FLK_white": "/countries_boundaries/FLK_white.png",
    "Falkland Islands_white": "/countries_boundaries/Falkland Islands_white.png",
    "FLK_blue": "/countries_boundaries/FLK_blue.png",
    "Falkland Islands_blue": "/countries_boundaries/Falkland Islands_blue.png",
    "CYM": "/countries_boundaries/CYM.png",
    "Cayman Islands": "/countries_boundaries/Cayman Islands.png",
    "CYM_white": "/countries_boundaries/CYM_white.png",
    "Cayman Islands_white": "/countries_boundaries/Cayman Islands_white.png",
    "CYM_blue": "/countries_boundaries/CYM_blue.png",
    "Cayman Islands_blue": "/countries_boundaries/Cayman Islands_blue.png",
    "BMU": "/countries_boundaries/BMU.png",
    "Bermuda": "/countries_boundaries/Bermuda.png",
    "BMU_white": "/countries_boundaries/BMU_white.png",
    "Bermuda_white": "/countries_boundaries/Bermuda_white.png",
    "BMU_blue": "/countries_boundaries/BMU_blue.png",
    "Bermuda_blue": "/countries_boundaries/Bermuda_blue.png",
    "VGB": "/countries_boundaries/VGB.png",
    "British Virgin Islands": "/countries_boundaries/British Virgin Islands.png",
    "VGB_white": "/countries_boundaries/VGB_white.png",
    "British Virgin Islands_white": "/countries_boundaries/British Virgin Islands_white.png",
    "VGB_blue": "/countries_boundaries/VGB_blue.png",
    "British Virgin Islands_blue": "/countries_boundaries/British Virgin Islands_blue.png",
    "TCA": "/countries_boundaries/TCA.png",
    "Turks and Caicos Islands": "/countries_boundaries/Turks and Caicos Islands.png",
    "TCA_white": "/countries_boundaries/TCA_white.png",
    "Turks and Caicos Islands_white": "/countries_boundaries/Turks and Caicos Islands_white.png",
    "TCA_blue": "/countries_boundaries/TCA_blue.png",
    "Turks and Caicos Islands_blue": "/countries_boundaries/Turks and Caicos Islands_blue.png",
    "MSR": "/countries_boundaries/MSR.png",
    "Montserrat": "/countries_boundaries/Montserrat.png",
    "MSR_white": "/countries_boundaries/MSR_white.png",
    "Montserrat_white": "/countries_boundaries/Montserrat_white.png",
    "MSR_blue": "/countries_boundaries/MSR_blue.png",
    "Montserrat_blue": "/countries_boundaries/Montserrat_blue.png",
    "JEY": "/countries_boundaries/JEY.png",
    "Jersey": "/countries_boundaries/Jersey.png",
    "JEY_white": "/countries_boundaries/JEY_white.png",
    "Jersey_white": "/countries_boundaries/Jersey_white.png",
    "JEY_blue": "/countries_boundaries/JEY_blue.png",
    "Jersey_blue": "/countries_boundaries/Jersey_blue.png",
    "GGY": "/countries_boundaries/GGY.png",
    "Guernsey": "/countries_boundaries/Guernsey.png",
    "GGY_white": "/countries_boundaries/GGY_white.png",
    "Guernsey_white": "/countries_boundaries/Guernsey_white.png",
    "GGY_blue": "/countries_boundaries/GGY_blue.png",
    "Guernsey_blue": "/countries_boundaries/Guernsey_blue.png",
    "IMN": "/countries_boundaries/IMN.png",
    "Isle of Man": "/countries_boundaries/Isle of Man.png",
    "IMN_white": "/countries_boundaries/IMN_white.png",
    "Isle of Man_white": "/countries_boundaries/Isle of Man_white.png",
    "IMN_blue": "/countries_boundaries/IMN_blue.png",
    "Isle of Man_blue": "/countries_boundaries/Isle of Man_blue.png",
    "UK": "/countries_boundaries/UK.png",
    "United Kingdom": "/countries_boundaries/United Kingdom.png",
    "UK_white": "/countries_boundaries/UK_white.png",
    "United Kingdom_white": "/countries_boundaries/United Kingdom_white.png",
    "UK_blue": "/countries_boundaries/UK_blue.png",
    "United Kingdom_blue": "/countries_boundaries/United Kingdom_blue.png",
    "UAE": "/countries_boundaries/UAE.png",
    "United Arab Emirates": "/countries_boundaries/United Arab Emirates.png",
    "UAE_white": "/countries_boundaries/UAE_white.png",
    "United Arab Emirates_white": "/countries_boundaries/United Arab Emirates_white.png",
    "UAE_blue": "/countries_boundaries/UAE_blue.png",
    "United Arab Emirates_blue": "/countries_boundaries/United Arab Emirates_blue.png",
    "UKR": "/countries_boundaries/UKR.png",
    "Ukraine": "/countries_boundaries/Ukraine.png",
    "UKR_white": "/countries_boundaries/UKR_white.png",
    "Ukraine_white": "/countries_boundaries/Ukraine_white.png",
    "UKR_blue": "/countries_boundaries/UKR_blue.png",
    "Ukraine_blue": "/countries_boundaries/Ukraine_blue.png",
    "UGA": "/countries_boundaries/UGA.png",
    "Uganda": "/countries_boundaries/Uganda.png",
    "UGA_white": "/countries_boundaries/UGA_white.png",
    "Uganda_white": "/countries_boundaries/Uganda_white.png",
    "UGA_blue": "/countries_boundaries/UGA_blue.png",
    "Uganda_blue": "/countries_boundaries/Uganda_blue.png",
    "TKM": "/countries_boundaries/TKM.png",
    "Turkmenistan": "/countries_boundaries/Turkmenistan.png",
    "TKM_white": "/countries_boundaries/TKM_white.png",
    "Turkmenistan_white": "/countries_boundaries/Turkmenistan_white.png",
    "TKM_blue": "/countries_boundaries/TKM_blue.png",
    "Turkmenistan_blue": "/countries_boundaries/Turkmenistan_blue.png",
    "TUR": "/countries_boundaries/TUR.png",
    "Turkey": "/countries_boundaries/Turkey.png",
    "TUR_white": "/countries_boundaries/TUR_white.png",
    "Turkey_white": "/countries_boundaries/Turkey_white.png",
    "TUR_blue": "/countries_boundaries/TUR_blue.png",
    "Turkey_blue": "/countries_boundaries/Turkey_blue.png",
    "TUN": "/countries_boundaries/TUN.png",
    "Tunisia": "/countries_boundaries/Tunisia.png",
    "TUN_white": "/countries_boundaries/TUN_white.png",
    "Tunisia_white": "/countries_boundaries/Tunisia_white.png",
    "TUN_blue": "/countries_boundaries/TUN_blue.png",
    "Tunisia_blue": "/countries_boundaries/Tunisia_blue.png",
    "TTO": "/countries_boundaries/TTO.png",
    "Trinidad and Tobago": "/countries_boundaries/Trinidad and Tobago.png",
    "TTO_white": "/countries_boundaries/TTO_white.png",
    "Trinidad and Tobago_white": "/countries_boundaries/Trinidad and Tobago_white.png",
    "TTO_blue": "/countries_boundaries/TTO_blue.png",
    "Trinidad and Tobago_blue": "/countries_boundaries/Trinidad and Tobago_blue.png",
    "TON": "/countries_boundaries/TON.png",
    "Tonga": "/countries_boundaries/Tonga.png",
    "TON_white": "/countries_boundaries/TON_white.png",
    "Tonga_white": "/countries_boundaries/Tonga_white.png",
    "TON_blue": "/countries_boundaries/TON_blue.png",
    "Tonga_blue": "/countries_boundaries/Tonga_blue.png",
    "TGO": "/countries_boundaries/TGO.png",
    "Togo": "/countries_boundaries/Togo.png",
    "TGO_white": "/countries_boundaries/TGO_white.png",
    "Togo_white": "/countries_boundaries/Togo_white.png",
    "TGO_blue": "/countries_boundaries/TGO_blue.png",
    "Togo_blue": "/countries_boundaries/Togo_blue.png",
    "TLS": "/countries_boundaries/TLS.png",
    "East Timor": "/countries_boundaries/East Timor.png",
    "TLS_white": "/countries_boundaries/TLS_white.png",
    "East Timor_white": "/countries_boundaries/East Timor_white.png",
    "TLS_blue": "/countries_boundaries/TLS_blue.png",
    "East Timor_blue": "/countries_boundaries/East Timor_blue.png",
    "THA": "/countries_boundaries/THA.png",
    "Thailand": "/countries_boundaries/Thailand.png",
    "THA_white": "/countries_boundaries/THA_white.png",
    "Thailand_white": "/countries_boundaries/Thailand_white.png",
    "THA_blue": "/countries_boundaries/THA_blue.png",
    "Thailand_blue": "/countries_boundaries/Thailand_blue.png",
    "TZA": "/countries_boundaries/TZA.png",
    "Tanzania": "/countries_boundaries/Tanzania.png",
    "TZA_white": "/countries_boundaries/TZA_white.png",
    "Tanzania_white": "/countries_boundaries/Tanzania_white.png",
    "TZA_blue": "/countries_boundaries/TZA_blue.png",
    "Tanzania_blue": "/countries_boundaries/Tanzania_blue.png",
    "TJK": "/countries_boundaries/TJK.png",
    "Tajikistan": "/countries_boundaries/Tajikistan.png",
    "TJK_white": "/countries_boundaries/TJK_white.png",
    "Tajikistan_white": "/countries_boundaries/Tajikistan_white.png",
    "TJK_blue": "/countries_boundaries/TJK_blue.png",
    "Tajikistan_blue": "/countries_boundaries/Tajikistan_blue.png",
    "TWN": "/countries_boundaries/TWN.png",
    "Taiwan": "/countries_boundaries/Taiwan.png",
    "TWN_white": "/countries_boundaries/TWN_white.png",
    "Taiwan_white": "/countries_boundaries/Taiwan_white.png",
    "TWN_blue": "/countries_boundaries/TWN_blue.png",
    "Taiwan_blue": "/countries_boundaries/Taiwan_blue.png",
    "SYR": "/countries_boundaries/SYR.png",
    "Syria": "/countries_boundaries/Syria.png",
    "SYR_white": "/countries_boundaries/SYR_white.png",
    "Syria_white": "/countries_boundaries/Syria_white.png",
    "SYR_blue": "/countries_boundaries/SYR_blue.png",
    "Syria_blue": "/countries_boundaries/Syria_blue.png",
    "CHE": "/countries_boundaries/CHE.png",
    "Switzerland": "/countries_boundaries/Switzerland.png",
    "CHE_white": "/countries_boundaries/CHE_white.png",
    "Switzerland_white": "/countries_boundaries/Switzerland_white.png",
    "CHE_blue": "/countries_boundaries/CHE_blue.png",
    "Switzerland_blue": "/countries_boundaries/Switzerland_blue.png",
    "SWE": "/countries_boundaries/SWE.png",
    "Sweden": "/countries_boundaries/Sweden.png",
    "SWE_white": "/countries_boundaries/SWE_white.png",
    "Sweden_white": "/countries_boundaries/Sweden_white.png",
    "SWE_blue": "/countries_boundaries/SWE_blue.png",
    "Sweden_blue": "/countries_boundaries/Sweden_blue.png",
    "SWAZILAND": "/countries_boundaries/SWAZILAND.png",
    "Eswatini": "/countries_boundaries/Eswatini.png",
    "SWAZILAND_white": "/countries_boundaries/SWAZILAND_white.png",
    "Eswatini_white": "/countries_boundaries/Eswatini_white.png",
    "SWAZILAND_blue": "/countries_boundaries/SWAZILAND_blue.png",
    "Eswatini_blue": "/countries_boundaries/Eswatini_blue.png",
    "SUR": "/countries_boundaries/SUR.png",
    "Suriname": "/countries_boundaries/Suriname.png",
    "SUR_white": "/countries_boundaries/SUR_white.png",
    "Suriname_white": "/countries_boundaries/Suriname_white.png",
    "SUR_blue": "/countries_boundaries/SUR_blue.png",
    "Suriname_blue": "/countries_boundaries/Suriname_blue.png",
    "SSD": "/countries_boundaries/SSD.png",
    "South Sudan": "/countries_boundaries/South Sudan.png",
    "SSD_white": "/countries_boundaries/SSD_white.png",
    "South Sudan_white": "/countries_boundaries/South Sudan_white.png",
    "SSD_blue": "/countries_boundaries/SSD_blue.png",
    "South Sudan_blue": "/countries_boundaries/South Sudan_blue.png",
    "SDN": "/countries_boundaries/SDN.png",
    "Sudan": "/countries_boundaries/Sudan.png",
    "SDN_white": "/countries_boundaries/SDN_white.png",
    "Sudan_white": "/countries_boundaries/Sudan_white.png",
    "SDN_blue": "/countries_boundaries/SDN_blue.png",
    "Sudan_blue": "/countries_boundaries/Sudan_blue.png",
    "LKA": "/countries_boundaries/LKA.png",
    "Sri Lanka": "/countries_boundaries/Sri Lanka.png",
    "LKA_white": "/countries_boundaries/LKA_white.png",
    "Sri Lanka_white": "/countries_boundaries/Sri Lanka_white.png",
    "LKA_blue": "/countries_boundaries/LKA_blue.png",
    "Sri Lanka_blue": "/countries_boundaries/Sri Lanka_blue.png",
    "ESP": "/countries_boundaries/ESP.png",
    "Spain": "/countries_boundaries/Spain.png",
    "ESP_white": "/countries_boundaries/ESP_white.png",
    "Spain_white": "/countries_boundaries/Spain_white.png",
    "ESP_blue": "/countries_boundaries/ESP_blue.png",
    "Spain_blue": "/countries_boundaries/Spain_blue.png",
    "KOR": "/countries_boundaries/KOR.png",
    "South Korea": "/countries_boundaries/South Korea.png",
    "KOR_white": "/countries_boundaries/KOR_white.png",
    "South Korea_white": "/countries_boundaries/South Korea_white.png",
    "KOR_blue": "/countries_boundaries/KOR_blue.png",
    "South Korea_blue": "/countries_boundaries/South Korea_blue.png",
    "ZAF": "/countries_boundaries/ZAF.png",
    "South Africa": "/countries_boundaries/South Africa.png",
    "ZAF_white": "/countries_boundaries/ZAF_white.png",
    "South Africa_white": "/countries_boundaries/South Africa_white.png",
    "ZAF_blue": "/countries_boundaries/ZAF_blue.png",
    "South Africa_blue": "/countries_boundaries/South Africa_blue.png",
    "SOM": "/countries_boundaries/SOM.png",
    "Somalia": "/countries_boundaries/Somalia.png",
    "SOM_white": "/countries_boundaries/SOM_white.png",
    "Somalia_white": "/countries_boundaries/Somalia_white.png",
    "SOM_blue": "/countries_boundaries/SOM_blue.png",
    "Somalia_blue": "/countries_boundaries/Somalia_blue.png",
    "SOMALI": "/countries_boundaries/SOMALI.png",
    "Somaliland": "/countries_boundaries/Somaliland.png",
    "SOMALI_white": "/countries_boundaries/SOMALI_white.png",
    "Somaliland_white": "/countries_boundaries/Somaliland_white.png",
    "SOMALI_blue": "/countries_boundaries/SOMALI_blue.png",
    "Somaliland_blue": "/countries_boundaries/Somaliland_blue.png",
    "SLB": "/countries_boundaries/SLB.png",
    "Solomon Islands": "/countries_boundaries/Solomon Islands.png",
    "SLB_white": "/countries_boundaries/SLB_white.png",
    "Solomon Islands_white": "/countries_boundaries/Solomon Islands_white.png",
    "SLB_blue": "/countries_boundaries/SLB_blue.png",
    "Solomon Islands_blue": "/countries_boundaries/Solomon Islands_blue.png",
    "SVK": "/countries_boundaries/SVK.png",
    "Slovakia": "/countries_boundaries/Slovakia.png",
    "SVK_white": "/countries_boundaries/SVK_white.png",
    "Slovakia_white": "/countries_boundaries/Slovakia_white.png",
    "SVK_blue": "/countries_boundaries/SVK_blue.png",
    "Slovakia_blue": "/countries_boundaries/Slovakia_blue.png",
    "SVN": "/countries_boundaries/SVN.png",
    "Slovenia": "/countries_boundaries/Slovenia.png",
    "SVN_white": "/countries_boundaries/SVN_white.png",
    "Slovenia_white": "/countries_boundaries/Slovenia_white.png",
    "SVN_blue": "/countries_boundaries/SVN_blue.png",
    "Slovenia_blue": "/countries_boundaries/Slovenia_blue.png",
    "SGP": "/countries_boundaries/SGP.png",
    "Singapore": "/countries_boundaries/Singapore.png",
    "SGP_white": "/countries_boundaries/SGP_white.png",
    "Singapore_white": "/countries_boundaries/Singapore_white.png",
    "SGP_blue": "/countries_boundaries/SGP_blue.png",
    "Singapore_blue": "/countries_boundaries/Singapore_blue.png",
    "SLE": "/countries_boundaries/SLE.png",
    "Sierra Leone": "/countries_boundaries/Sierra Leone.png",
    "SLE_white": "/countries_boundaries/SLE_white.png",
    "Sierra Leone_white": "/countries_boundaries/Sierra Leone_white.png",
    "SLE_blue": "/countries_boundaries/SLE_blue.png",
    "Sierra Leone_blue": "/countries_boundaries/Sierra Leone_blue.png",
    "SYC": "/countries_boundaries/SYC.png",
    "Seychelles": "/countries_boundaries/Seychelles.png",
    "SYC_white": "/countries_boundaries/SYC_white.png",
    "Seychelles_white": "/countries_boundaries/Seychelles_white.png",
    "SYC_blue": "/countries_boundaries/SYC_blue.png",
    "Seychelles_blue": "/countries_boundaries/Seychelles_blue.png",
    "SRB": "/countries_boundaries/SRB.png",
    "Serbia": "/countries_boundaries/Serbia.png",
    "SRB_white": "/countries_boundaries/SRB_white.png",
    "Serbia_white": "/countries_boundaries/Serbia_white.png",
    "SRB_blue": "/countries_boundaries/SRB_blue.png",
    "Serbia_blue": "/countries_boundaries/Serbia_blue.png",
    "SEN": "/countries_boundaries/SEN.png",
    "Senegal": "/countries_boundaries/Senegal.png",
    "SEN_white": "/countries_boundaries/SEN_white.png",
    "Senegal_white": "/countries_boundaries/Senegal_white.png",
    "SEN_blue": "/countries_boundaries/SEN_blue.png",
    "Senegal_blue": "/countries_boundaries/Senegal_blue.png",
    "SAU": "/countries_boundaries/SAU.png",
    "Saudi Arabia": "/countries_boundaries/Saudi Arabia.png",
    "SAU_white": "/countries_boundaries/SAU_white.png",
    "Saudi Arabia_white": "/countries_boundaries/Saudi Arabia_white.png",
    "SAU_blue": "/countries_boundaries/SAU_blue.png",
    "Saudi Arabia_blue": "/countries_boundaries/Saudi Arabia_blue.png",
    "STP": "/countries_boundaries/STP.png",
    "São Tomé and Príncipe": "/countries_boundaries/São Tomé and Príncipe.png",
    "STP_white": "/countries_boundaries/STP_white.png",
    "São Tomé and Príncipe_white": "/countries_boundaries/São Tomé and Príncipe_white.png",
    "STP_blue": "/countries_boundaries/STP_blue.png",
    "São Tomé and Príncipe_blue": "/countries_boundaries/São Tomé and Príncipe_blue.png",
    "SMR": "/countries_boundaries/SMR.png",
    "San Marino": "/countries_boundaries/San Marino.png",
    "SMR_white": "/countries_boundaries/SMR_white.png",
    "San Marino_white": "/countries_boundaries/San Marino_white.png",
    "SMR_blue": "/countries_boundaries/SMR_blue.png",
    "San Marino_blue": "/countries_boundaries/San Marino_blue.png",
    "WSM": "/countries_boundaries/WSM.png",
    "Samoa": "/countries_boundaries/Samoa.png",
    "WSM_white": "/countries_boundaries/WSM_white.png",
    "Samoa_white": "/countries_boundaries/Samoa_white.png",
    "WSM_blue": "/countries_boundaries/WSM_blue.png",
    "Samoa_blue": "/countries_boundaries/Samoa_blue.png",
    "VCT": "/countries_boundaries/VCT.png",
    "Saint Vincent and the Grenadines": "/countries_boundaries/Saint Vincent and the Grenadines.png",
    "VCT_white": "/countries_boundaries/VCT_white.png",
    "Saint Vincent and the Grenadines_white": "/countries_boundaries/Saint Vincent and the Grenadines_white.png",
    "VCT_blue": "/countries_boundaries/VCT_blue.png",
    "Saint Vincent and the Grenadines_blue": "/countries_boundaries/Saint Vincent and the Grenadines_blue.png",
    "LCA": "/countries_boundaries/LCA.png",
    "Saint Lucia": "/countries_boundaries/Saint Lucia.png",
    "LCA_white": "/countries_boundaries/LCA_white.png",
    "Saint Lucia_white": "/countries_boundaries/Saint Lucia_white.png",
    "LCA_blue": "/countries_boundaries/LCA_blue.png",
    "Saint Lucia_blue": "/countries_boundaries/Saint Lucia_blue.png",
    "KNA": "/countries_boundaries/KNA.png",
    "Saint Kitts and Nevis": "/countries_boundaries/Saint Kitts and Nevis.png",
    "KNA_white": "/countries_boundaries/KNA_white.png",
    "Saint Kitts and Nevis_white": "/countries_boundaries/Saint Kitts and Nevis_white.png",
    "KNA_blue": "/countries_boundaries/KNA_blue.png",
    "Saint Kitts and Nevis_blue": "/countries_boundaries/Saint Kitts and Nevis_blue.png",
    "RWA": "/countries_boundaries/RWA.png",
    "Rwanda": "/countries_boundaries/Rwanda.png",
    "RWA_white": "/countries_boundaries/RWA_white.png",
    "Rwanda_white": "/countries_boundaries/Rwanda_white.png",
    "RWA_blue": "/countries_boundaries/RWA_blue.png",
    "Rwanda_blue": "/countries_boundaries/Rwanda_blue.png",
    "RUS": "/countries_boundaries/RUS.png",
    "Russia": "/countries_boundaries/Russia.png",
    "RUS_white": "/countries_boundaries/RUS_white.png",
    "Russia_white": "/countries_boundaries/Russia_white.png",
    "RUS_blue": "/countries_boundaries/RUS_blue.png",
    "Russia_blue": "/countries_boundaries/Russia_blue.png",
    "ROU": "/countries_boundaries/ROU.png",
    "Romania": "/countries_boundaries/Romania.png",
    "ROU_white": "/countries_boundaries/ROU_white.png",
    "Romania_white": "/countries_boundaries/Romania_white.png",
    "ROU_blue": "/countries_boundaries/ROU_blue.png",
    "Romania_blue": "/countries_boundaries/Romania_blue.png",
    "QAT": "/countries_boundaries/QAT.png",
    "Qatar": "/countries_boundaries/Qatar.png",
    "QAT_white": "/countries_boundaries/QAT_white.png",
    "Qatar_white": "/countries_boundaries/Qatar_white.png",
    "QAT_blue": "/countries_boundaries/QAT_blue.png",
    "Qatar_blue": "/countries_boundaries/Qatar_blue.png",
    "PRT": "/countries_boundaries/PRT.png",
    "Portugal": "/countries_boundaries/Portugal.png",
    "PRT_white": "/countries_boundaries/PRT_white.png",
    "Portugal_white": "/countries_boundaries/Portugal_white.png",
    "PRT_blue": "/countries_boundaries/PRT_blue.png",
    "Portugal_blue": "/countries_boundaries/Portugal_blue.png",
    "POL": "/countries_boundaries/POL.png",
    "Poland": "/countries_boundaries/Poland.png",
    "POL_white": "/countries_boundaries/POL_white.png",
    "Poland_white": "/countries_boundaries/Poland_white.png",
    "POL_blue": "/countries_boundaries/POL_blue.png",
    "Poland_blue": "/countries_boundaries/Poland_blue.png",
    "PHL": "/countries_boundaries/PHL.png",
    "Philippines": "/countries_boundaries/Philippines.png",
    "PHL_white": "/countries_boundaries/PHL_white.png",
    "Philippines_white": "/countries_boundaries/Philippines_white.png",
    "PHL_blue": "/countries_boundaries/PHL_blue.png",
    "Philippines_blue": "/countries_boundaries/Philippines_blue.png",
    "PER": "/countries_boundaries/PER.png",
    "Peru": "/countries_boundaries/Peru.png",
    "PER_white": "/countries_boundaries/PER_white.png",
    "Peru_white": "/countries_boundaries/Peru_white.png",
    "PER_blue": "/countries_boundaries/PER_blue.png",
    "Peru_blue": "/countries_boundaries/Peru_blue.png",
    "PRY": "/countries_boundaries/PRY.png",
    "Paraguay": "/countries_boundaries/Paraguay.png",
    "PRY_white": "/countries_boundaries/PRY_white.png",
    "Paraguay_white": "/countries_boundaries/Paraguay_white.png",
    "PRY_blue": "/countries_boundaries/PRY_blue.png",
    "Paraguay_blue": "/countries_boundaries/Paraguay_blue.png",
    "PNG": "/countries_boundaries/PNG.png",
    "Papua New Guinea": "/countries_boundaries/Papua New Guinea.png",
    "PNG_white": "/countries_boundaries/PNG_white.png",
    "Papua New Guinea_white": "/countries_boundaries/Papua New Guinea_white.png",
    "PNG_blue": "/countries_boundaries/PNG_blue.png",
    "Papua New Guinea_blue": "/countries_boundaries/Papua New Guinea_blue.png",
    "PAN": "/countries_boundaries/PAN.png",
    "Panama": "/countries_boundaries/Panama.png",
    "PAN_white": "/countries_boundaries/PAN_white.png",
    "Panama_white": "/countries_boundaries/Panama_white.png",
    "PAN_blue": "/countries_boundaries/PAN_blue.png",
    "Panama_blue": "/countries_boundaries/Panama_blue.png",
    "PLW": "/countries_boundaries/PLW.png",
    "Palau": "/countries_boundaries/Palau.png",
    "PLW_white": "/countries_boundaries/PLW_white.png",
    "Palau_white": "/countries_boundaries/Palau_white.png",
    "PLW_blue": "/countries_boundaries/PLW_blue.png",
    "Palau_blue": "/countries_boundaries/Palau_blue.png",
    "PAK": "/countries_boundaries/PAK.png",
    "Pakistan": "/countries_boundaries/Pakistan.png",
    "PAK_white": "/countries_boundaries/PAK_white.png",
    "Pakistan_white": "/countries_boundaries/Pakistan_white.png",
    "PAK_blue": "/countries_boundaries/PAK_blue.png",
    "Pakistan_blue": "/countries_boundaries/Pakistan_blue.png",
    "OMN": "/countries_boundaries/OMN.png",
    "Oman": "/countries_boundaries/Oman.png",
    "OMN_white": "/countries_boundaries/OMN_white.png",
    "Oman_white": "/countries_boundaries/Oman_white.png",
    "OMN_blue": "/countries_boundaries/OMN_blue.png",
    "Oman_blue": "/countries_boundaries/Oman_blue.png",
    "NORWAY": "/countries_boundaries/NORWAY.png",
    "Norway": "/countries_boundaries/Norway.png",
    "NORWAY_white": "/countries_boundaries/NORWAY_white.png",
    "Norway_white": "/countries_boundaries/Norway_white.png",
    "NORWAY_blue": "/countries_boundaries/NORWAY_blue.png",
    "Norway_blue": "/countries_boundaries/Norway_blue.png",
    "PRK": "/countries_boundaries/PRK.png",
    "North Korea": "/countries_boundaries/North Korea.png",
    "PRK_white": "/countries_boundaries/PRK_white.png",
    "North Korea_white": "/countries_boundaries/North Korea_white.png",
    "PRK_blue": "/countries_boundaries/PRK_blue.png",
    "North Korea_blue": "/countries_boundaries/North Korea_blue.png",
    "NGA": "/countries_boundaries/NGA.png",
    "Nigeria": "/countries_boundaries/Nigeria.png",
    "NGA_white": "/countries_boundaries/NGA_white.png",
    "Nigeria_white": "/countries_boundaries/Nigeria_white.png",
    "NGA_blue": "/countries_boundaries/NGA_blue.png",
    "Nigeria_blue": "/countries_boundaries/Nigeria_blue.png",
    "NER": "/countries_boundaries/NER.png",
    "Niger": "/countries_boundaries/Niger.png",
    "NER_white": "/countries_boundaries/NER_white.png",
    "Niger_white": "/countries_boundaries/Niger_white.png",
    "NER_blue": "/countries_boundaries/NER_blue.png",
    "Niger_blue": "/countries_boundaries/Niger_blue.png",
    "NIC": "/countries_boundaries/NIC.png",
    "Nicaragua": "/countries_boundaries/Nicaragua.png",
    "NIC_white": "/countries_boundaries/NIC_white.png",
    "Nicaragua_white": "/countries_boundaries/Nicaragua_white.png",
    "NIC_blue": "/countries_boundaries/NIC_blue.png",
    "Nicaragua_blue": "/countries_boundaries/Nicaragua_blue.png",
    "NZL": "/countries_boundaries/NZL.png",
    "New Zealand": "/countries_boundaries/New Zealand.png",
    "NZL_white": "/countries_boundaries/NZL_white.png",
    "New Zealand_white": "/countries_boundaries/New Zealand_white.png",
    "NZL_blue": "/countries_boundaries/NZL_blue.png",
    "New Zealand_blue": "/countries_boundaries/New Zealand_blue.png",
    "NIU": "/countries_boundaries/NIU.png",
    "Niue": "/countries_boundaries/Niue.png",
    "NIU_white": "/countries_boundaries/NIU_white.png",
    "Niue_white": "/countries_boundaries/Niue_white.png",
    "NIU_blue": "/countries_boundaries/NIU_blue.png",
    "Niue_blue": "/countries_boundaries/Niue_blue.png",
    "COK": "/countries_boundaries/COK.png",
    "Cook Islands": "/countries_boundaries/Cook Islands.png",
    "COK_white": "/countries_boundaries/COK_white.png",
    "Cook Islands_white": "/countries_boundaries/Cook Islands_white.png",
    "COK_blue": "/countries_boundaries/COK_blue.png",
    "Cook Islands_blue": "/countries_boundaries/Cook Islands_blue.png",
    "NLD": "/countries_boundaries/NLD.png",
    "Netherlands": "/countries_boundaries/Netherlands.png",
    "NLD_white": "/countries_boundaries/NLD_white.png",
    "Netherlands_white": "/countries_boundaries/Netherlands_white.png",
    "NLD_blue": "/countries_boundaries/NLD_blue.png",
    "Netherlands_blue": "/countries_boundaries/Netherlands_blue.png",
    "ABW": "/countries_boundaries/ABW.png",
    "Aruba": "/countries_boundaries/Aruba.png",
    "ABW_white": "/countries_boundaries/ABW_white.png",
    "Aruba_white": "/countries_boundaries/Aruba_white.png",
    "ABW_blue": "/countries_boundaries/ABW_blue.png",
    "Aruba_blue": "/countries_boundaries/Aruba_blue.png",
    "CUW": "/countries_boundaries/CUW.png",
    "Curaçao": "/countries_boundaries/Curaçao.png",
    "CUW_white": "/countries_boundaries/CUW_white.png",
    "Curaçao_white": "/countries_boundaries/Curaçao_white.png",
    "CUW_blue": "/countries_boundaries/CUW_blue.png",
    "Curaçao_blue": "/countries_boundaries/Curaçao_blue.png",
    "NPL": "/countries_boundaries/NPL.png",
    "Nepal": "/countries_boundaries/Nepal.png",
    "NPL_white": "/countries_boundaries/NPL_white.png",
    "Nepal_white": "/countries_boundaries/Nepal_white.png",
    "NPL_blue": "/countries_boundaries/NPL_blue.png",
    "Nepal_blue": "/countries_boundaries/Nepal_blue.png",
    "NRU": "/countries_boundaries/NRU.png",
    "Nauru": "/countries_boundaries/Nauru.png",
    "NRU_white": "/countries_boundaries/NRU_white.png",
    "Nauru_white": "/countries_boundaries/Nauru_white.png",
    "NRU_blue": "/countries_boundaries/NRU_blue.png",
    "Nauru_blue": "/countries_boundaries/Nauru_blue.png",
    "NAM": "/countries_boundaries/NAM.png",
    "Namibia": "/countries_boundaries/Namibia.png",
    "NAM_white": "/countries_boundaries/NAM_white.png",
    "Namibia_white": "/countries_boundaries/Namibia_white.png",
    "NAM_blue": "/countries_boundaries/NAM_blue.png",
    "Namibia_blue": "/countries_boundaries/Namibia_blue.png",
    "MOZ": "/countries_boundaries/MOZ.png",
    "Mozambique": "/countries_boundaries/Mozambique.png",
    "MOZ_white": "/countries_boundaries/MOZ_white.png",
    "Mozambique_white": "/countries_boundaries/Mozambique_white.png",
    "MOZ_blue": "/countries_boundaries/MOZ_blue.png",
    "Mozambique_blue": "/countries_boundaries/Mozambique_blue.png",
    "MAR": "/countries_boundaries/MAR.png",
    "Morocco": "/countries_boundaries/Morocco.png",
    "MAR_white": "/countries_boundaries/MAR_white.png",
    "Morocco_white": "/countries_boundaries/Morocco_white.png",
    "MAR_blue": "/countries_boundaries/MAR_blue.png",
    "Morocco_blue": "/countries_boundaries/Morocco_blue.png",
    "ESH": "/countries_boundaries/ESH.png",
    "Western Sahara": "/countries_boundaries/Western Sahara.png",
    "ESH_white": "/countries_boundaries/ESH_white.png",
    "Western Sahara_white": "/countries_boundaries/Western Sahara_white.png",
    "ESH_blue": "/countries_boundaries/ESH_blue.png",
    "Western Sahara_blue": "/countries_boundaries/Western Sahara_blue.png",
    "MNE": "/countries_boundaries/MNE.png",
    "Montenegro": "/countries_boundaries/Montenegro.png",
    "MNE_white": "/countries_boundaries/MNE_white.png",
    "Montenegro_white": "/countries_boundaries/Montenegro_white.png",
    "MNE_blue": "/countries_boundaries/MNE_blue.png",
    "Montenegro_blue": "/countries_boundaries/Montenegro_blue.png",
    "MNG": "/countries_boundaries/MNG.png",
    "Mongolia": "/countries_boundaries/Mongolia.png",
    "MNG_white": "/countries_boundaries/MNG_white.png",
    "Mongolia_white": "/countries_boundaries/Mongolia_white.png",
    "MNG_blue": "/countries_boundaries/MNG_blue.png",
    "Mongolia_blue": "/countries_boundaries/Mongolia_blue.png",
    "MDA": "/countries_boundaries/MDA.png",
    "Moldova": "/countries_boundaries/Moldova.png",
    "MDA_white": "/countries_boundaries/MDA_white.png",
    "Moldova_white": "/countries_boundaries/Moldova_white.png",
    "MDA_blue": "/countries_boundaries/MDA_blue.png",
    "Moldova_blue": "/countries_boundaries/Moldova_blue.png",
    "MCO": "/countries_boundaries/MCO.png",
    "Monaco": "/countries_boundaries/Monaco.png",
    "MCO_white": "/countries_boundaries/MCO_white.png",
    "Monaco_white": "/countries_boundaries/Monaco_white.png",
    "MCO_blue": "/countries_boundaries/MCO_blue.png",
    "Monaco_blue": "/countries_boundaries/Monaco_blue.png",
    "MEX": "/countries_boundaries/MEX.png",
    "Mexico": "/countries_boundaries/Mexico.png",
    "MEX_white": "/countries_boundaries/MEX_white.png",
    "Mexico_white": "/countries_boundaries/Mexico_white.png",
    "MEX_blue": "/countries_boundaries/MEX_blue.png",
    "Mexico_blue": "/countries_boundaries/Mexico_blue.png",
    "MUS": "/countries_boundaries/MUS.png",
    "Mauritius": "/countries_boundaries/Mauritius.png",
    "MUS_white": "/countries_boundaries/MUS_white.png",
    "Mauritius_white": "/countries_boundaries/Mauritius_white.png",
    "MUS_blue": "/countries_boundaries/MUS_blue.png",
    "Mauritius_blue": "/countries_boundaries/Mauritius_blue.png",
    "MRT": "/countries_boundaries/MRT.png",
    "Mauritania": "/countries_boundaries/Mauritania.png",
    "MRT_white": "/countries_boundaries/MRT_white.png",
    "Mauritania_white": "/countries_boundaries/Mauritania_white.png",
    "MRT_blue": "/countries_boundaries/MRT_blue.png",
    "Mauritania_blue": "/countries_boundaries/Mauritania_blue.png",
    "MLT": "/countries_boundaries/MLT.png",
    "Malta": "/countries_boundaries/Malta.png",
    "MLT_white": "/countries_boundaries/MLT_white.png",
    "Malta_white": "/countries_boundaries/Malta_white.png",
    "MLT_blue": "/countries_boundaries/MLT_blue.png",
    "Malta_blue": "/countries_boundaries/Malta_blue.png",
    "MLI": "/countries_boundaries/MLI.png",
    "Mali": "/countries_boundaries/Mali.png",
    "MLI_white": "/countries_boundaries/MLI_white.png",
    "Mali_white": "/countries_boundaries/Mali_white.png",
    "MLI_blue": "/countries_boundaries/MLI_blue.png",
    "Mali_blue": "/countries_boundaries/Mali_blue.png",
    "MDV": "/countries_boundaries/MDV.png",
    "Maldives": "/countries_boundaries/Maldives.png",
    "MDV_white": "/countries_boundaries/MDV_white.png",
    "Maldives_white": "/countries_boundaries/Maldives_white.png",
    "MDV_blue": "/countries_boundaries/MDV_blue.png",
    "Maldives_blue": "/countries_boundaries/Maldives_blue.png",
    "MYS": "/countries_boundaries/MYS.png",
    "Malaysia": "/countries_boundaries/Malaysia.png",
    "MYS_white": "/countries_boundaries/MYS_white.png",
    "Malaysia_white": "/countries_boundaries/Malaysia_white.png",
    "MYS_blue": "/countries_boundaries/MYS_blue.png",
    "Malaysia_blue": "/countries_boundaries/Malaysia_blue.png",
    "MWI": "/countries_boundaries/MWI.png",
    "Malawi": "/countries_boundaries/Malawi.png",
    "MWI_white": "/countries_boundaries/MWI_white.png",
    "Malawi_white": "/countries_boundaries/Malawi_white.png",
    "MWI_blue": "/countries_boundaries/MWI_blue.png",
    "Malawi_blue": "/countries_boundaries/Malawi_blue.png",
    "MDG": "/countries_boundaries/MDG.png",
    "Madagascar": "/countries_boundaries/Madagascar.png",
    "MDG_white": "/countries_boundaries/MDG_white.png",
    "Madagascar_white": "/countries_boundaries/Madagascar_white.png",
    "MDG_blue": "/countries_boundaries/MDG_blue.png",
    "Madagascar_blue": "/countries_boundaries/Madagascar_blue.png",
    "MKD": "/countries_boundaries/MKD.png",
    "North Macedonia": "/countries_boundaries/North Macedonia.png",
    "MKD_white": "/countries_boundaries/MKD_white.png",
    "North Macedonia_white": "/countries_boundaries/North Macedonia_white.png",
    "MKD_blue": "/countries_boundaries/MKD_blue.png",
    "North Macedonia_blue": "/countries_boundaries/North Macedonia_blue.png",
    "LUX": "/countries_boundaries/LUX.png",
    "Luxembourg": "/countries_boundaries/Luxembourg.png",
    "LUX_white": "/countries_boundaries/LUX_white.png",
    "Luxembourg_white": "/countries_boundaries/Luxembourg_white.png",
    "LUX_blue": "/countries_boundaries/LUX_blue.png",
    "Luxembourg_blue": "/countries_boundaries/Luxembourg_blue.png",
    "LTU": "/countries_boundaries/LTU.png",
    "Lithuania": "/countries_boundaries/Lithuania.png",
    "LTU_white": "/countries_boundaries/LTU_white.png",
    "Lithuania_white": "/countries_boundaries/Lithuania_white.png",
    "LTU_blue": "/countries_boundaries/LTU_blue.png",
    "Lithuania_blue": "/countries_boundaries/Lithuania_blue.png",
    "LIE": "/countries_boundaries/LIE.png",
    "Liechtenstein": "/countries_boundaries/Liechtenstein.png",
    "LIE_white": "/countries_boundaries/LIE_white.png",
    "Liechtenstein_white": "/countries_boundaries/Liechtenstein_white.png",
    "LIE_blue": "/countries_boundaries/LIE_blue.png",
    "Liechtenstein_blue": "/countries_boundaries/Liechtenstein_blue.png",
    "LBY": "/countries_boundaries/LBY.png",
    "Libya": "/countries_boundaries/Libya.png",
    "LBY_white": "/countries_boundaries/LBY_white.png",
    "Libya_white": "/countries_boundaries/Libya_white.png",
    "LBY_blue": "/countries_boundaries/LBY_blue.png",
    "Libya_blue": "/countries_boundaries/Libya_blue.png",
    "LBR": "/countries_boundaries/LBR.png",
    "Liberia": "/countries_boundaries/Liberia.png",
    "LBR_white": "/countries_boundaries/LBR_white.png",
    "Liberia_white": "/countries_boundaries/Liberia_white.png",
    "LBR_blue": "/countries_boundaries/LBR_blue.png",
    "Liberia_blue": "/countries_boundaries/Liberia_blue.png",
    "LSO": "/countries_boundaries/LSO.png",
    "Lesotho": "/countries_boundaries/Lesotho.png",
    "LSO_white": "/countries_boundaries/LSO_white.png",
    "Lesotho_white": "/countries_boundaries/Lesotho_white.png",
    "LSO_blue": "/countries_boundaries/LSO_blue.png",
    "Lesotho_blue": "/countries_boundaries/Lesotho_blue.png",
    "LBN": "/countries_boundaries/LBN.png",
    "Lebanon": "/countries_boundaries/Lebanon.png",
    "LBN_white": "/countries_boundaries/LBN_white.png",
    "Lebanon_white": "/countries_boundaries/Lebanon_white.png",
    "LBN_blue": "/countries_boundaries/LBN_blue.png",
    "Lebanon_blue": "/countries_boundaries/Lebanon_blue.png",
    "LVA": "/countries_boundaries/LVA.png",
    "Latvia": "/countries_boundaries/Latvia.png",
    "LVA_white": "/countries_boundaries/LVA_white.png",
    "Latvia_white": "/countries_boundaries/Latvia_white.png",
    "LVA_blue": "/countries_boundaries/LVA_blue.png",
    "Latvia_blue": "/countries_boundaries/Latvia_blue.png",
    "LAO": "/countries_boundaries/LAO.png",
    "Laos": "/countries_boundaries/Laos.png",
    "LAO_white": "/countries_boundaries/LAO_white.png",
    "Laos_white": "/countries_boundaries/Laos_white.png",
    "LAO_blue": "/countries_boundaries/LAO_blue.png",
    "Laos_blue": "/countries_boundaries/Laos_blue.png",
    "KGZ": "/countries_boundaries/KGZ.png",
    "Kyrgyzstan": "/countries_boundaries/Kyrgyzstan.png",
    "KGZ_white": "/countries_boundaries/KGZ_white.png",
    "Kyrgyzstan_white": "/countries_boundaries/Kyrgyzstan_white.png",
    "KGZ_blue": "/countries_boundaries/KGZ_blue.png",
    "Kyrgyzstan_blue": "/countries_boundaries/Kyrgyzstan_blue.png",
    "KWT": "/countries_boundaries/KWT.png",
    "Kuwait": "/countries_boundaries/Kuwait.png",
    "KWT_white": "/countries_boundaries/KWT_white.png",
    "Kuwait_white": "/countries_boundaries/Kuwait_white.png",
    "KWT_blue": "/countries_boundaries/KWT_blue.png",
    "Kuwait_blue": "/countries_boundaries/Kuwait_blue.png",
    "KOSOVO": "/countries_boundaries/KOSOVO.png",
    "Kosovo": "/countries_boundaries/Kosovo.png",
    "KOSOVO_white": "/countries_boundaries/KOSOVO_white.png",
    "Kosovo_white": "/countries_boundaries/Kosovo_white.png",
    "KOSOVO_blue": "/countries_boundaries/KOSOVO_blue.png",
    "Kosovo_blue": "/countries_boundaries/Kosovo_blue.png",
    "KIR": "/countries_boundaries/KIR.png",
    "Kiribati": "/countries_boundaries/Kiribati.png",
    "KIR_white": "/countries_boundaries/KIR_white.png",
    "Kiribati_white": "/countries_boundaries/Kiribati_white.png",
    "KIR_blue": "/countries_boundaries/KIR_blue.png",
    "Kiribati_blue": "/countries_boundaries/Kiribati_blue.png",
    "KEN": "/countries_boundaries/KEN.png",
    "Kenya": "/countries_boundaries/Kenya.png",
    "KEN_white": "/countries_boundaries/KEN_white.png",
    "Kenya_white": "/countries_boundaries/Kenya_white.png",
    "KEN_blue": "/countries_boundaries/KEN_blue.png",
    "Kenya_blue": "/countries_boundaries/Kenya_blue.png",
    "KAZ": "/countries_boundaries/KAZ.png",
    "Kazakhstan": "/countries_boundaries/Kazakhstan.png",
    "KAZ_white": "/countries_boundaries/KAZ_white.png",
    "Kazakhstan_white": "/countries_boundaries/Kazakhstan_white.png",
    "KAZ_blue": "/countries_boundaries/KAZ_blue.png",
    "Kazakhstan_blue": "/countries_boundaries/Kazakhstan_blue.png",
    "JOR": "/countries_boundaries/JOR.png",
    "Jordan": "/countries_boundaries/Jordan.png",
    "JOR_white": "/countries_boundaries/JOR_white.png",
    "Jordan_white": "/countries_boundaries/Jordan_white.png",
    "JOR_blue": "/countries_boundaries/JOR_blue.png",
    "Jordan_blue": "/countries_boundaries/Jordan_blue.png",
    "JPN": "/countries_boundaries/JPN.png",
    "Japan": "/countries_boundaries/Japan.png",
    "JPN_white": "/countries_boundaries/JPN_white.png",
    "Japan_white": "/countries_boundaries/Japan_white.png",
    "JPN_blue": "/countries_boundaries/JPN_blue.png",
    "Japan_blue": "/countries_boundaries/Japan_blue.png",
    "JAM": "/countries_boundaries/JAM.png",
    "Jamaica": "/countries_boundaries/Jamaica.png",
    "JAM_white": "/countries_boundaries/JAM_white.png",
    "Jamaica_white": "/countries_boundaries/Jamaica_white.png",
    "JAM_blue": "/countries_boundaries/JAM_blue.png",
    "Jamaica_blue": "/countries_boundaries/Jamaica_blue.png",
    "ITA": "/countries_boundaries/ITA.png",
    "Italy": "/countries_boundaries/Italy.png",
    "ITA_white": "/countries_boundaries/ITA_white.png",
    "Italy_white": "/countries_boundaries/Italy_white.png",
    "ITA_blue": "/countries_boundaries/ITA_blue.png",
    "Italy_blue": "/countries_boundaries/Italy_blue.png",
    "ISR": "/countries_boundaries/ISR.png",
    "Israel": "/countries_boundaries/Israel.png",
    "ISR_white": "/countries_boundaries/ISR_white.png",
    "Israel_white": "/countries_boundaries/Israel_white.png",
    "ISR_blue": "/countries_boundaries/ISR_blue.png",
    "Israel_blue": "/countries_boundaries/Israel_blue.png",
    "PSE": "/countries_boundaries/PSE.png",
    "Palestine": "/countries_boundaries/Palestine.png",
    "PSE_white": "/countries_boundaries/PSE_white.png",
    "Palestine_white": "/countries_boundaries/Palestine_white.png",
    "PSE_blue": "/countries_boundaries/PSE_blue.png",
    "Palestine_blue": "/countries_boundaries/Palestine_blue.png",
    "IRL": "/countries_boundaries/IRL.png",
    "Ireland": "/countries_boundaries/Ireland.png",
    "IRL_white": "/countries_boundaries/IRL_white.png",
    "Ireland_white": "/countries_boundaries/Ireland_white.png",
    "IRL_blue": "/countries_boundaries/IRL_blue.png",
    "Ireland_blue": "/countries_boundaries/Ireland_blue.png",
    "IRQ": "/countries_boundaries/IRQ.png",
    "Iraq": "/countries_boundaries/Iraq.png",
    "IRQ_white": "/countries_boundaries/IRQ_white.png",
    "Iraq_white": "/countries_boundaries/Iraq_white.png",
    "IRQ_blue": "/countries_boundaries/IRQ_blue.png",
    "Iraq_blue": "/countries_boundaries/Iraq_blue.png",
    "IRN": "/countries_boundaries/IRN.png",
    "Iran": "/countries_boundaries/Iran.png",
    "IRN_white": "/countries_boundaries/IRN_white.png",
    "Iran_white": "/countries_boundaries/Iran_white.png",
    "IRN_blue": "/countries_boundaries/IRN_blue.png",
    "Iran_blue": "/countries_boundaries/Iran_blue.png",
    "IDN": "/countries_boundaries/IDN.png",
    "Indonesia": "/countries_boundaries/Indonesia.png",
    "IDN_white": "/countries_boundaries/IDN_white.png",
    "Indonesia_white": "/countries_boundaries/Indonesia_white.png",
    "IDN_blue": "/countries_boundaries/IDN_blue.png",
    "Indonesia_blue": "/countries_boundaries/Indonesia_blue.png",
    "IND": "/countries_boundaries/IND.png",
    "India": "/countries_boundaries/India.png",
    "IND_white": "/countries_boundaries/IND_white.png",
    "India_white": "/countries_boundaries/India_white.png",
    "IND_blue": "/countries_boundaries/IND_blue.png",
    "India_blue": "/countries_boundaries/India_blue.png",
    "ISL": "/countries_boundaries/ISL.png",
    "Iceland": "/countries_boundaries/Iceland.png",
    "ISL_white": "/countries_boundaries/ISL_white.png",
    "Iceland_white": "/countries_boundaries/Iceland_white.png",
    "ISL_blue": "/countries_boundaries/ISL_blue.png",
    "Iceland_blue": "/countries_boundaries/Iceland_blue.png",
    "HUN": "/countries_boundaries/HUN.png",
    "Hungary": "/countries_boundaries/Hungary.png",
    "HUN_white": "/countries_boundaries/HUN_white.png",
    "Hungary_white": "/countries_boundaries/Hungary_white.png",
    "HUN_blue": "/countries_boundaries/HUN_blue.png",
    "Hungary_blue": "/countries_boundaries/Hungary_blue.png",
    "HND": "/countries_boundaries/HND.png",
    "Honduras": "/countries_boundaries/Honduras.png",
    "HND_white": "/countries_boundaries/HND_white.png",
    "Honduras_white": "/countries_boundaries/Honduras_white.png",
    "HND_blue": "/countries_boundaries/HND_blue.png",
    "Honduras_blue": "/countries_boundaries/Honduras_blue.png",
    "HTI": "/countries_boundaries/HTI.png",
    "Haiti": "/countries_boundaries/Haiti.png",
    "HTI_white": "/countries_boundaries/HTI_white.png",
    "Haiti_white": "/countries_boundaries/Haiti_white.png",
    "HTI_blue": "/countries_boundaries/HTI_blue.png",
    "Haiti_blue": "/countries_boundaries/Haiti_blue.png",
    "GUY": "/countries_boundaries/GUY.png",
    "Guyana": "/countries_boundaries/Guyana.png",
    "GUY_white": "/countries_boundaries/GUY_white.png",
    "Guyana_white": "/countries_boundaries/Guyana_white.png",
    "GUY_blue": "/countries_boundaries/GUY_blue.png",
    "Guyana_blue": "/countries_boundaries/Guyana_blue.png",
    "GNB": "/countries_boundaries/GNB.png",
    "Guinea-Bissau": "/countries_boundaries/Guinea-Bissau.png",
    "GNB_white": "/countries_boundaries/GNB_white.png",
    "Guinea-Bissau_white": "/countries_boundaries/Guinea-Bissau_white.png",
    "GNB_blue": "/countries_boundaries/GNB_blue.png",
    "Guinea-Bissau_blue": "/countries_boundaries/Guinea-Bissau_blue.png",
    "GIN": "/countries_boundaries/GIN.png",
    "Guinea": "/countries_boundaries/Guinea.png",
    "GIN_white": "/countries_boundaries/GIN_white.png",
    "Guinea_white": "/countries_boundaries/Guinea_white.png",
    "GIN_blue": "/countries_boundaries/GIN_blue.png",
    "Guinea_blue": "/countries_boundaries/Guinea_blue.png",
    "GTM": "/countries_boundaries/GTM.png",
    "Guatemala": "/countries_boundaries/Guatemala.png",
    "GTM_white": "/countries_boundaries/GTM_white.png",
    "Guatemala_white": "/countries_boundaries/Guatemala_white.png",
    "GTM_blue": "/countries_boundaries/GTM_blue.png",
    "Guatemala_blue": "/countries_boundaries/Guatemala_blue.png",
    "GRD": "/countries_boundaries/GRD.png",
    "Grenada": "/countries_boundaries/Grenada.png",
    "GRD_white": "/countries_boundaries/GRD_white.png",
    "Grenada_white": "/countries_boundaries/Grenada_white.png",
    "GRD_blue": "/countries_boundaries/GRD_blue.png",
    "Grenada_blue": "/countries_boundaries/Grenada_blue.png",
    "GRC": "/countries_boundaries/GRC.png",
    "Greece": "/countries_boundaries/Greece.png",
    "GRC_white": "/countries_boundaries/GRC_white.png",
    "Greece_white": "/countries_boundaries/Greece_white.png",
    "GRC_blue": "/countries_boundaries/GRC_blue.png",
    "Greece_blue": "/countries_boundaries/Greece_blue.png",
    "GHA": "/countries_boundaries/GHA.png",
    "Ghana": "/countries_boundaries/Ghana.png",
    "GHA_white": "/countries_boundaries/GHA_white.png",
    "Ghana_white": "/countries_boundaries/Ghana_white.png",
    "GHA_blue": "/countries_boundaries/GHA_blue.png",
    "Ghana_blue": "/countries_boundaries/Ghana_blue.png",
    "DEU": "/countries_boundaries/DEU.png",
    "Germany": "/countries_boundaries/Germany.png",
    "DEU_white": "/countries_boundaries/DEU_white.png",
    "Germany_white": "/countries_boundaries/Germany_white.png",
    "DEU_blue": "/countries_boundaries/DEU_blue.png",
    "Germany_blue": "/countries_boundaries/Germany_blue.png",
    "GEO": "/countries_boundaries/GEO.png",
    "Georgia": "/countries_boundaries/Georgia.png",
    "GEO_white": "/countries_boundaries/GEO_white.png",
    "Georgia_white": "/countries_boundaries/Georgia_white.png",
    "GEO_blue": "/countries_boundaries/GEO_blue.png",
    "Georgia_blue": "/countries_boundaries/Georgia_blue.png",
    "GMB": "/countries_boundaries/GMB.png",
    "The Gambia": "/countries_boundaries/The Gambia.png",
    "GMB_white": "/countries_boundaries/GMB_white.png",
    "The Gambia_white": "/countries_boundaries/The Gambia_white.png",
    "GMB_blue": "/countries_boundaries/GMB_blue.png",
    "The Gambia_blue": "/countries_boundaries/The Gambia_blue.png",
    "GAB": "/countries_boundaries/GAB.png",
    "Gabon": "/countries_boundaries/Gabon.png",
    "GAB_white": "/countries_boundaries/GAB_white.png",
    "Gabon_white": "/countries_boundaries/Gabon_white.png",
    "GAB_blue": "/countries_boundaries/GAB_blue.png",
    "Gabon_blue": "/countries_boundaries/Gabon_blue.png",
    "FRANCE": "/countries_boundaries/FRANCE.png",
    "France": "/countries_boundaries/France.png",
    "FRANCE_white": "/countries_boundaries/FRANCE_white.png",
    "France_white": "/countries_boundaries/France_white.png",
    "FRANCE_blue": "/countries_boundaries/FRANCE_blue.png",
    "France_blue": "/countries_boundaries/France_blue.png",
    "SPM": "/countries_boundaries/SPM.png",
    "Saint Pierre and Miquelon": "/countries_boundaries/Saint Pierre and Miquelon.png",
    "SPM_white": "/countries_boundaries/SPM_white.png",
    "Saint Pierre and Miquelon_white": "/countries_boundaries/Saint Pierre and Miquelon_white.png",
    "SPM_blue": "/countries_boundaries/SPM_blue.png",
    "Saint Pierre and Miquelon_blue": "/countries_boundaries/Saint Pierre and Miquelon_blue.png",
    "WLF": "/countries_boundaries/WLF.png",
    "Wallis and Futuna": "/countries_boundaries/Wallis and Futuna.png",
    "WLF_white": "/countries_boundaries/WLF_white.png",
    "Wallis and Futuna_white": "/countries_boundaries/Wallis and Futuna_white.png",
    "WLF_blue": "/countries_boundaries/WLF_blue.png",
    "Wallis and Futuna_blue": "/countries_boundaries/Wallis and Futuna_blue.png",
    "MAF": "/countries_boundaries/MAF.png",
    "Saint Martin": "/countries_boundaries/Saint Martin.png",
    "MAF_white": "/countries_boundaries/MAF_white.png",
    "Saint Martin_white": "/countries_boundaries/Saint Martin_white.png",
    "MAF_blue": "/countries_boundaries/MAF_blue.png",
    "Saint Martin_blue": "/countries_boundaries/Saint Martin_blue.png",
    "BLM": "/countries_boundaries/BLM.png",
    "Saint Barthélemy": "/countries_boundaries/Saint Barthélemy.png",
    "BLM_white": "/countries_boundaries/BLM_white.png",
    "Saint Barthélemy_white": "/countries_boundaries/Saint Barthélemy_white.png",
    "BLM_blue": "/countries_boundaries/BLM_blue.png",
    "Saint Barthélemy_blue": "/countries_boundaries/Saint Barthélemy_blue.png",
    "PYF": "/countries_boundaries/PYF.png",
    "French Polynesia": "/countries_boundaries/French Polynesia.png",
    "PYF_white": "/countries_boundaries/PYF_white.png",
    "French Polynesia_white": "/countries_boundaries/French Polynesia_white.png",
    "PYF_blue": "/countries_boundaries/PYF_blue.png",
    "French Polynesia_blue": "/countries_boundaries/French Polynesia_blue.png",
    "NCL": "/countries_boundaries/NCL.png",
    "New Caledonia": "/countries_boundaries/New Caledonia.png",
    "NCL_white": "/countries_boundaries/NCL_white.png",
    "New Caledonia_white": "/countries_boundaries/New Caledonia_white.png",
    "NCL_blue": "/countries_boundaries/NCL_blue.png",
    "New Caledonia_blue": "/countries_boundaries/New Caledonia_blue.png",
    "ATF": "/countries_boundaries/ATF.png",
    "French Southern and Antarctic Lands": "/countries_boundaries/French Southern and Antarctic Lands.png",
    "ATF_white": "/countries_boundaries/ATF_white.png",
    "French Southern and Antarctic Lands_white": "/countries_boundaries/French Southern and Antarctic Lands_white.png",
    "ATF_blue": "/countries_boundaries/ATF_blue.png",
    "French Southern and Antarctic Lands_blue": "/countries_boundaries/French Southern and Antarctic Lands_blue.png",
    "ALA": "/countries_boundaries/ALA.png",
    "Åland": "/countries_boundaries/Åland.png",
    "ALA_white": "/countries_boundaries/ALA_white.png",
    "Åland_white": "/countries_boundaries/Åland_white.png",
    "ALA_blue": "/countries_boundaries/ALA_blue.png",
    "Åland_blue": "/countries_boundaries/Åland_blue.png",
    "FIN": "/countries_boundaries/FIN.png",
    "Finland": "/countries_boundaries/Finland.png",
    "FIN_white": "/countries_boundaries/FIN_white.png",
    "Finland_white": "/countries_boundaries/Finland_white.png",
    "FIN_blue": "/countries_boundaries/FIN_blue.png",
    "Finland_blue": "/countries_boundaries/Finland_blue.png",
    "FJI": "/countries_boundaries/FJI.png",
    "Fiji": "/countries_boundaries/Fiji.png",
    "FJI_white": "/countries_boundaries/FJI_white.png",
    "Fiji_white": "/countries_boundaries/Fiji_white.png",
    "FJI_blue": "/countries_boundaries/FJI_blue.png",
    "Fiji_blue": "/countries_boundaries/Fiji_blue.png",
    "ETH": "/countries_boundaries/ETH.png",
    "Ethiopia": "/countries_boundaries/Ethiopia.png",
    "ETH_white": "/countries_boundaries/ETH_white.png",
    "Ethiopia_white": "/countries_boundaries/Ethiopia_white.png",
    "ETH_blue": "/countries_boundaries/ETH_blue.png",
    "Ethiopia_blue": "/countries_boundaries/Ethiopia_blue.png",
    "EST": "/countries_boundaries/EST.png",
    "Estonia": "/countries_boundaries/Estonia.png",
    "EST_white": "/countries_boundaries/EST_white.png",
    "Estonia_white": "/countries_boundaries/Estonia_white.png",
    "EST_blue": "/countries_boundaries/EST_blue.png",
    "Estonia_blue": "/countries_boundaries/Estonia_blue.png",
    "ERI": "/countries_boundaries/ERI.png",
    "Eritrea": "/countries_boundaries/Eritrea.png",
    "ERI_white": "/countries_boundaries/ERI_white.png",
    "Eritrea_white": "/countries_boundaries/Eritrea_white.png",
    "ERI_blue": "/countries_boundaries/ERI_blue.png",
    "Eritrea_blue": "/countries_boundaries/Eritrea_blue.png",
    "GNQ": "/countries_boundaries/GNQ.png",
    "Equatorial Guinea": "/countries_boundaries/Equatorial Guinea.png",
    "GNQ_white": "/countries_boundaries/GNQ_white.png",
    "Equatorial Guinea_white": "/countries_boundaries/Equatorial Guinea_white.png",
    "GNQ_blue": "/countries_boundaries/GNQ_blue.png",
    "Equatorial Guinea_blue": "/countries_boundaries/Equatorial Guinea_blue.png",
    "SLV": "/countries_boundaries/SLV.png",
    "El Salvador": "/countries_boundaries/El Salvador.png",
    "SLV_white": "/countries_boundaries/SLV_white.png",
    "El Salvador_white": "/countries_boundaries/El Salvador_white.png",
    "SLV_blue": "/countries_boundaries/SLV_blue.png",
    "El Salvador_blue": "/countries_boundaries/El Salvador_blue.png",
    "EGY": "/countries_boundaries/EGY.png",
    "Egypt": "/countries_boundaries/Egypt.png",
    "EGY_white": "/countries_boundaries/EGY_white.png",
    "Egypt_white": "/countries_boundaries/Egypt_white.png",
    "EGY_blue": "/countries_boundaries/EGY_blue.png",
    "Egypt_blue": "/countries_boundaries/Egypt_blue.png",
    "ECU": "/countries_boundaries/ECU.png",
    "Ecuador": "/countries_boundaries/Ecuador.png",
    "ECU_white": "/countries_boundaries/ECU_white.png",
    "Ecuador_white": "/countries_boundaries/Ecuador_white.png",
    "ECU_blue": "/countries_boundaries/ECU_blue.png",
    "Ecuador_blue": "/countries_boundaries/Ecuador_blue.png",
    "DOM": "/countries_boundaries/DOM.png",
    "Dominican Republic": "/countries_boundaries/Dominican Republic.png",
    "DOM_white": "/countries_boundaries/DOM_white.png",
    "Dominican Republic_white": "/countries_boundaries/Dominican Republic_white.png",
    "DOM_blue": "/countries_boundaries/DOM_blue.png",
    "Dominican Republic_blue": "/countries_boundaries/Dominican Republic_blue.png",
    "DMA": "/countries_boundaries/DMA.png",
    "Dominica": "/countries_boundaries/Dominica.png",
    "DMA_white": "/countries_boundaries/DMA_white.png",
    "Dominica_white": "/countries_boundaries/Dominica_white.png",
    "DMA_blue": "/countries_boundaries/DMA_blue.png",
    "Dominica_blue": "/countries_boundaries/Dominica_blue.png",
    "DJI": "/countries_boundaries/DJI.png",
    "Djibouti": "/countries_boundaries/Djibouti.png",
    "DJI_white": "/countries_boundaries/DJI_white.png",
    "Djibouti_white": "/countries_boundaries/Djibouti_white.png",
    "DJI_blue": "/countries_boundaries/DJI_blue.png",
    "Djibouti_blue": "/countries_boundaries/Djibouti_blue.png",
    "GRL": "/countries_boundaries/GRL.png",
    "Greenland": "/countries_boundaries/Greenland.png",
    "GRL_white": "/countries_boundaries/GRL_white.png",
    "Greenland_white": "/countries_boundaries/Greenland_white.png",
    "GRL_blue": "/countries_boundaries/GRL_blue.png",
    "Greenland_blue": "/countries_boundaries/Greenland_blue.png",
    "FRO": "/countries_boundaries/FRO.png",
    "Faroe Islands": "/countries_boundaries/Faroe Islands.png",
    "FRO_white": "/countries_boundaries/FRO_white.png",
    "Faroe Islands_white": "/countries_boundaries/Faroe Islands_white.png",
    "FRO_blue": "/countries_boundaries/FRO_blue.png",
    "Faroe Islands_blue": "/countries_boundaries/Faroe Islands_blue.png",
    "DNK": "/countries_boundaries/DNK.png",
    "Denmark": "/countries_boundaries/Denmark.png",
    "DNK_white": "/countries_boundaries/DNK_white.png",
    "Denmark_white": "/countries_boundaries/Denmark_white.png",
    "DNK_blue": "/countries_boundaries/DNK_blue.png",
    "Denmark_blue": "/countries_boundaries/Denmark_blue.png",
    "CZE": "/countries_boundaries/CZE.png",
    "Czech Republic": "/countries_boundaries/Czech Republic.png",
    "CZE_white": "/countries_boundaries/CZE_white.png",
    "Czech Republic_white": "/countries_boundaries/Czech Republic_white.png",
    "CZE_blue": "/countries_boundaries/CZE_blue.png",
    "Czech Republic_blue": "/countries_boundaries/Czech Republic_blue.png",
    "TURKIS": "/countries_boundaries/TURKIS.png",
    "Turkish Republic of Northern Cyprus": "/countries_boundaries/Turkish Republic of Northern Cyprus.png",
    "TURKIS_white": "/countries_boundaries/TURKIS_white.png",
    "Turkish Republic of Northern Cyprus_white": "/countries_boundaries/Turkish Republic of Northern Cyprus_white.png",
    "TURKIS_blue": "/countries_boundaries/TURKIS_blue.png",
    "Turkish Republic of Northern Cyprus_blue": "/countries_boundaries/Turkish Republic of Northern Cyprus_blue.png",
    "CYP": "/countries_boundaries/CYP.png",
    "Cyprus": "/countries_boundaries/Cyprus.png",
    "CYP_white": "/countries_boundaries/CYP_white.png",
    "Cyprus_white": "/countries_boundaries/Cyprus_white.png",
    "CYP_blue": "/countries_boundaries/CYP_blue.png",
    "Cyprus_blue": "/countries_boundaries/Cyprus_blue.png",
    "CUB": "/countries_boundaries/CUB.png",
    "Cuba": "/countries_boundaries/Cuba.png",
    "CUB_white": "/countries_boundaries/CUB_white.png",
    "Cuba_white": "/countries_boundaries/Cuba_white.png",
    "CUB_blue": "/countries_boundaries/CUB_blue.png",
    "Cuba_blue": "/countries_boundaries/Cuba_blue.png",
    "HRV": "/countries_boundaries/HRV.png",
    "Croatia": "/countries_boundaries/Croatia.png",
    "HRV_white": "/countries_boundaries/HRV_white.png",
    "Croatia_white": "/countries_boundaries/Croatia_white.png",
    "HRV_blue": "/countries_boundaries/HRV_blue.png",
    "Croatia_blue": "/countries_boundaries/Croatia_blue.png",
    "CIV": "/countries_boundaries/CIV.png",
    "Ivory Coast": "/countries_boundaries/Ivory Coast.png",
    "CIV_white": "/countries_boundaries/CIV_white.png",
    "Ivory Coast_white": "/countries_boundaries/Ivory Coast_white.png",
    "CIV_blue": "/countries_boundaries/CIV_blue.png",
    "Ivory Coast_blue": "/countries_boundaries/Ivory Coast_blue.png",
    "CRI": "/countries_boundaries/CRI.png",
    "Costa Rica": "/countries_boundaries/Costa Rica.png",
    "CRI_white": "/countries_boundaries/CRI_white.png",
    "Costa Rica_white": "/countries_boundaries/Costa Rica_white.png",
    "CRI_blue": "/countries_boundaries/CRI_blue.png",
    "Costa Rica_blue": "/countries_boundaries/Costa Rica_blue.png",
    "COD": "/countries_boundaries/COD.png",
    "Democratic Republic of the Congo": "/countries_boundaries/Democratic Republic of the Congo.png",
    "COD_white": "/countries_boundaries/COD_white.png",
    "Democratic Republic of the Congo_white": "/countries_boundaries/Democratic Republic of the Congo_white.png",
    "COD_blue": "/countries_boundaries/COD_blue.png",
    "Democratic Republic of the Congo_blue": "/countries_boundaries/Democratic Republic of the Congo_blue.png",
    "COG": "/countries_boundaries/COG.png",
    "Republic of the Congo": "/countries_boundaries/Republic of the Congo.png",
    "COG_white": "/countries_boundaries/COG_white.png",
    "Republic of the Congo_white": "/countries_boundaries/Republic of the Congo_white.png",
    "COG_blue": "/countries_boundaries/COG_blue.png",
    "Republic of the Congo_blue": "/countries_boundaries/Republic of the Congo_blue.png",
    "COM": "/countries_boundaries/COM.png",
    "Comoros": "/countries_boundaries/Comoros.png",
    "COM_white": "/countries_boundaries/COM_white.png",
    "Comoros_white": "/countries_boundaries/Comoros_white.png",
    "COM_blue": "/countries_boundaries/COM_blue.png",
    "Comoros_blue": "/countries_boundaries/Comoros_blue.png",
    "COL": "/countries_boundaries/COL.png",
    "Colombia": "/countries_boundaries/Colombia.png",
    "COL_white": "/countries_boundaries/COL_white.png",
    "Colombia_white": "/countries_boundaries/Colombia_white.png",
    "COL_blue": "/countries_boundaries/COL_blue.png",
    "Colombia_blue": "/countries_boundaries/Colombia_blue.png",
    "CHN": "/countries_boundaries/CHN.png",
    "People's Republic of China": "/countries_boundaries/People's Republic of China.png",
    "CHN_white": "/countries_boundaries/CHN_white.png",
    "People's Republic of China_white": "/countries_boundaries/People's Republic of China_white.png",
    "CHN_blue": "/countries_boundaries/CHN_blue.png",
    "People's Republic of China_blue": "/countries_boundaries/People's Republic of China_blue.png",
    "MAC": "/countries_boundaries/MAC.png",
    "Macau": "/countries_boundaries/Macau.png",
    "MAC_white": "/countries_boundaries/MAC_white.png",
    "Macau_white": "/countries_boundaries/Macau_white.png",
    "MAC_blue": "/countries_boundaries/MAC_blue.png",
    "Macau_blue": "/countries_boundaries/Macau_blue.png",
    "HKG": "/countries_boundaries/HKG.png",
    "Hong Kong": "/countries_boundaries/Hong Kong.png",
    "HKG_white": "/countries_boundaries/HKG_white.png",
    "Hong Kong_white": "/countries_boundaries/Hong Kong_white.png",
    "HKG_blue": "/countries_boundaries/HKG_blue.png",
    "Hong Kong_blue": "/countries_boundaries/Hong Kong_blue.png",
    "CHL": "/countries_boundaries/CHL.png",
    "Chile": "/countries_boundaries/Chile.png",
    "CHL_white": "/countries_boundaries/CHL_white.png",
    "Chile_white": "/countries_boundaries/Chile_white.png",
    "CHL_blue": "/countries_boundaries/CHL_blue.png",
    "Chile_blue": "/countries_boundaries/Chile_blue.png",
    "TCD": "/countries_boundaries/TCD.png",
    "Chad": "/countries_boundaries/Chad.png",
    "TCD_white": "/countries_boundaries/TCD_white.png",
    "Chad_white": "/countries_boundaries/Chad_white.png",
    "TCD_blue": "/countries_boundaries/TCD_blue.png",
    "Chad_blue": "/countries_boundaries/Chad_blue.png",
    "CAR": "/countries_boundaries/CAR.png",
    "Central African Republic": "/countries_boundaries/Central African Republic.png",
    "CAR_white": "/countries_boundaries/CAR_white.png",
    "Central African Republic_white": "/countries_boundaries/Central African Republic_white.png",
    "CAR_blue": "/countries_boundaries/CAR_blue.png",
    "Central African Republic_blue": "/countries_boundaries/Central African Republic_blue.png",
    "CPV": "/countries_boundaries/CPV.png",
    "Cape Verde": "/countries_boundaries/Cape Verde.png",
    "CPV_white": "/countries_boundaries/CPV_white.png",
    "Cape Verde_white": "/countries_boundaries/Cape Verde_white.png",
    "CPV_blue": "/countries_boundaries/CPV_blue.png",
    "Cape Verde_blue": "/countries_boundaries/Cape Verde_blue.png",
    "CAN": "/countries_boundaries/CAN.png",
    "Canada": "/countries_boundaries/Canada.png",
    "CAN_white": "/countries_boundaries/CAN_white.png",
    "Canada_white": "/countries_boundaries/Canada_white.png",
    "CAN_blue": "/countries_boundaries/CAN_blue.png",
    "Canada_blue": "/countries_boundaries/Canada_blue.png",
    "CMR": "/countries_boundaries/CMR.png",
    "Cameroon": "/countries_boundaries/Cameroon.png",
    "CMR_white": "/countries_boundaries/CMR_white.png",
    "Cameroon_white": "/countries_boundaries/Cameroon_white.png",
    "CMR_blue": "/countries_boundaries/CMR_blue.png",
    "Cameroon_blue": "/countries_boundaries/Cameroon_blue.png",
    "KHM": "/countries_boundaries/KHM.png",
    "Cambodia": "/countries_boundaries/Cambodia.png",
    "KHM_white": "/countries_boundaries/KHM_white.png",
    "Cambodia_white": "/countries_boundaries/Cambodia_white.png",
    "KHM_blue": "/countries_boundaries/KHM_blue.png",
    "Cambodia_blue": "/countries_boundaries/Cambodia_blue.png",
    "MMR": "/countries_boundaries/MMR.png",
    "Myanmar": "/countries_boundaries/Myanmar.png",
    "MMR_white": "/countries_boundaries/MMR_white.png",
    "Myanmar_white": "/countries_boundaries/Myanmar_white.png",
    "MMR_blue": "/countries_boundaries/MMR_blue.png",
    "Myanmar_blue": "/countries_boundaries/Myanmar_blue.png",
    "BDI": "/countries_boundaries/BDI.png",
    "Burundi": "/countries_boundaries/Burundi.png",
    "BDI_white": "/countries_boundaries/BDI_white.png",
    "Burundi_white": "/countries_boundaries/Burundi_white.png",
    "BDI_blue": "/countries_boundaries/BDI_blue.png",
    "Burundi_blue": "/countries_boundaries/Burundi_blue.png",
    "BFA": "/countries_boundaries/BFA.png",
    "Burkina Faso": "/countries_boundaries/Burkina Faso.png",
    "BFA_white": "/countries_boundaries/BFA_white.png",
    "Burkina Faso_white": "/countries_boundaries/Burkina Faso_white.png",
    "BFA_blue": "/countries_boundaries/BFA_blue.png",
    "Burkina Faso_blue": "/countries_boundaries/Burkina Faso_blue.png",
    "BGR": "/countries_boundaries/BGR.png",
    "Bulgaria": "/countries_boundaries/Bulgaria.png",
    "BGR_white": "/countries_boundaries/BGR_white.png",
    "Bulgaria_white": "/countries_boundaries/Bulgaria_white.png",
    "BGR_blue": "/countries_boundaries/BGR_blue.png",
    "Bulgaria_blue": "/countries_boundaries/Bulgaria_blue.png",
    "BRN": "/countries_boundaries/BRN.png",
    "Brunei": "/countries_boundaries/Brunei.png",
    "BRN_white": "/countries_boundaries/BRN_white.png",
    "Brunei_white": "/countries_boundaries/Brunei_white.png",
    "BRN_blue": "/countries_boundaries/BRN_blue.png",
    "Brunei_blue": "/countries_boundaries/Brunei_blue.png",
    "BRA": "/countries_boundaries/BRA.png",
    "Brazil": "/countries_boundaries/Brazil.png",
    "BRA_white": "/countries_boundaries/BRA_white.png",
    "Brazil_white": "/countries_boundaries/Brazil_white.png",
    "BRA_blue": "/countries_boundaries/BRA_blue.png",
    "Brazil_blue": "/countries_boundaries/Brazil_blue.png",
    "BWA": "/countries_boundaries/BWA.png",
    "Botswana": "/countries_boundaries/Botswana.png",
    "BWA_white": "/countries_boundaries/BWA_white.png",
    "Botswana_white": "/countries_boundaries/Botswana_white.png",
    "BWA_blue": "/countries_boundaries/BWA_blue.png",
    "Botswana_blue": "/countries_boundaries/Botswana_blue.png",
    "BIH": "/countries_boundaries/BIH.png",
    "Bosnia and Herzegovina": "/countries_boundaries/Bosnia and Herzegovina.png",
    "BIH_white": "/countries_boundaries/BIH_white.png",
    "Bosnia and Herzegovina_white": "/countries_boundaries/Bosnia and Herzegovina_white.png",
    "BIH_blue": "/countries_boundaries/BIH_blue.png",
    "Bosnia and Herzegovina_blue": "/countries_boundaries/Bosnia and Herzegovina_blue.png",
    "BOL": "/countries_boundaries/BOL.png",
    "Bolivia": "/countries_boundaries/Bolivia.png",
    "BOL_white": "/countries_boundaries/BOL_white.png",
    "Bolivia_white": "/countries_boundaries/Bolivia_white.png",
    "BOL_blue": "/countries_boundaries/BOL_blue.png",
    "Bolivia_blue": "/countries_boundaries/Bolivia_blue.png",
    "BTN": "/countries_boundaries/BTN.png",
    "Bhutan": "/countries_boundaries/Bhutan.png",
    "BTN_white": "/countries_boundaries/BTN_white.png",
    "Bhutan_white": "/countries_boundaries/Bhutan_white.png",
    "BTN_blue": "/countries_boundaries/BTN_blue.png",
    "Bhutan_blue": "/countries_boundaries/Bhutan_blue.png",
    "BEN": "/countries_boundaries/BEN.png",
    "Benin": "/countries_boundaries/Benin.png",
    "BEN_white": "/countries_boundaries/BEN_white.png",
    "Benin_white": "/countries_boundaries/Benin_white.png",
    "BEN_blue": "/countries_boundaries/BEN_blue.png",
    "Benin_blue": "/countries_boundaries/Benin_blue.png",
    "BLZ": "/countries_boundaries/BLZ.png",
    "Belize": "/countries_boundaries/Belize.png",
    "BLZ_white": "/countries_boundaries/BLZ_white.png",
    "Belize_white": "/countries_boundaries/Belize_white.png",
    "BLZ_blue": "/countries_boundaries/BLZ_blue.png",
    "Belize_blue": "/countries_boundaries/Belize_blue.png",
    "BEL": "/countries_boundaries/BEL.png",
    "Belgium": "/countries_boundaries/Belgium.png",
    "BEL_white": "/countries_boundaries/BEL_white.png",
    "Belgium_white": "/countries_boundaries/Belgium_white.png",
    "BEL_blue": "/countries_boundaries/BEL_blue.png",
    "Belgium_blue": "/countries_boundaries/Belgium_blue.png",
    "BLR": "/countries_boundaries/BLR.png",
    "Belarus": "/countries_boundaries/Belarus.png",
    "BLR_white": "/countries_boundaries/BLR_white.png",
    "Belarus_white": "/countries_boundaries/Belarus_white.png",
    "BLR_blue": "/countries_boundaries/BLR_blue.png",
    "Belarus_blue": "/countries_boundaries/Belarus_blue.png",
    "BRB": "/countries_boundaries/BRB.png",
    "Barbados": "/countries_boundaries/Barbados.png",
    "BRB_white": "/countries_boundaries/BRB_white.png",
    "Barbados_white": "/countries_boundaries/Barbados_white.png",
    "BRB_blue": "/countries_boundaries/BRB_blue.png",
    "Barbados_blue": "/countries_boundaries/Barbados_blue.png",
    "BGD": "/countries_boundaries/BGD.png",
    "Bangladesh": "/countries_boundaries/Bangladesh.png",
    "BGD_white": "/countries_boundaries/BGD_white.png",
    "Bangladesh_white": "/countries_boundaries/Bangladesh_white.png",
    "BGD_blue": "/countries_boundaries/BGD_blue.png",
    "Bangladesh_blue": "/countries_boundaries/Bangladesh_blue.png",
    "BHR": "/countries_boundaries/BHR.png",
    "Bahrain": "/countries_boundaries/Bahrain.png",
    "BHR_white": "/countries_boundaries/BHR_white.png",
    "Bahrain_white": "/countries_boundaries/Bahrain_white.png",
    "BHR_blue": "/countries_boundaries/BHR_blue.png",
    "Bahrain_blue": "/countries_boundaries/Bahrain_blue.png",
    "BHS": "/countries_boundaries/BHS.png",
    "The Bahamas": "/countries_boundaries/The Bahamas.png",
    "BHS_white": "/countries_boundaries/BHS_white.png",
    "The Bahamas_white": "/countries_boundaries/The Bahamas_white.png",
    "BHS_blue": "/countries_boundaries/BHS_blue.png",
    "The Bahamas_blue": "/countries_boundaries/The Bahamas_blue.png",
    "AZE": "/countries_boundaries/AZE.png",
    "Azerbaijan": "/countries_boundaries/Azerbaijan.png",
    "AZE_white": "/countries_boundaries/AZE_white.png",
    "Azerbaijan_white": "/countries_boundaries/Azerbaijan_white.png",
    "AZE_blue": "/countries_boundaries/AZE_blue.png",
    "Azerbaijan_blue": "/countries_boundaries/Azerbaijan_blue.png",
    "AUT": "/countries_boundaries/AUT.png",
    "Austria": "/countries_boundaries/Austria.png",
    "AUT_white": "/countries_boundaries/AUT_white.png",
    "Austria_white": "/countries_boundaries/Austria_white.png",
    "AUT_blue": "/countries_boundaries/AUT_blue.png",
    "Austria_blue": "/countries_boundaries/Austria_blue.png",
    "AUS": "/countries_boundaries/AUS.png",
    "Australia": "/countries_boundaries/Australia.png",
    "AUS_white": "/countries_boundaries/AUS_white.png",
    "Australia_white": "/countries_boundaries/Australia_white.png",
    "AUS_blue": "/countries_boundaries/AUS_blue.png",
    "Australia_blue": "/countries_boundaries/Australia_blue.png",
    "AUSTRA": "/countries_boundaries/AUSTRA.png",
    "Australian Indian Ocean Territories": "/countries_boundaries/Australian Indian Ocean Territories.png",
    "AUSTRA_white": "/countries_boundaries/AUSTRA_white.png",
    "Australian Indian Ocean Territories_white": "/countries_boundaries/Australian Indian Ocean Territories_white.png",
    "AUSTRA_blue": "/countries_boundaries/AUSTRA_blue.png",
    "Australian Indian Ocean Territories_blue": "/countries_boundaries/Australian Indian Ocean Territories_blue.png",
    "HMD": "/countries_boundaries/HMD.png",
    "Heard Island and McDonald Islands": "/countries_boundaries/Heard Island and McDonald Islands.png",
    "HMD_white": "/countries_boundaries/HMD_white.png",
    "Heard Island and McDonald Islands_white": "/countries_boundaries/Heard Island and McDonald Islands_white.png",
    "HMD_blue": "/countries_boundaries/HMD_blue.png",
    "Heard Island and McDonald Islands_blue": "/countries_boundaries/Heard Island and McDonald Islands_blue.png",
    "NFK": "/countries_boundaries/NFK.png",
    "Norfolk Island": "/countries_boundaries/Norfolk Island.png",
    "NFK_white": "/countries_boundaries/NFK_white.png",
    "Norfolk Island_white": "/countries_boundaries/Norfolk Island_white.png",
    "NFK_blue": "/countries_boundaries/NFK_blue.png",
    "Norfolk Island_blue": "/countries_boundaries/Norfolk Island_blue.png",
    "ASHMOR": "/countries_boundaries/ASHMOR.png",
    "Ashmore and Cartier Islands": "/countries_boundaries/Ashmore and Cartier Islands.png",
    "ASHMOR_white": "/countries_boundaries/ASHMOR_white.png",
    "Ashmore and Cartier Islands_white": "/countries_boundaries/Ashmore and Cartier Islands_white.png",
    "ASHMOR_blue": "/countries_boundaries/ASHMOR_blue.png",
    "Ashmore and Cartier Islands_blue": "/countries_boundaries/Ashmore and Cartier Islands_blue.png",
    "ARM": "/countries_boundaries/ARM.png",
    "Armenia": "/countries_boundaries/Armenia.png",
    "ARM_white": "/countries_boundaries/ARM_white.png",
    "Armenia_white": "/countries_boundaries/Armenia_white.png",
    "ARM_blue": "/countries_boundaries/ARM_blue.png",
    "Armenia_blue": "/countries_boundaries/Armenia_blue.png",
    "ARG": "/countries_boundaries/ARG.png",
    "Argentina": "/countries_boundaries/Argentina.png",
    "ARG_white": "/countries_boundaries/ARG_white.png",
    "Argentina_white": "/countries_boundaries/Argentina_white.png",
    "ARG_blue": "/countries_boundaries/ARG_blue.png",
    "Argentina_blue": "/countries_boundaries/Argentina_blue.png",
    "ATG": "/countries_boundaries/ATG.png",
    "Antigua and Barbuda": "/countries_boundaries/Antigua and Barbuda.png",
    "ATG_white": "/countries_boundaries/ATG_white.png",
    "Antigua and Barbuda_white": "/countries_boundaries/Antigua and Barbuda_white.png",
    "ATG_blue": "/countries_boundaries/ATG_blue.png",
    "Antigua and Barbuda_blue": "/countries_boundaries/Antigua and Barbuda_blue.png",
    "AGO": "/countries_boundaries/AGO.png",
    "Angola": "/countries_boundaries/Angola.png",
    "AGO_white": "/countries_boundaries/AGO_white.png",
    "Angola_white": "/countries_boundaries/Angola_white.png",
    "AGO_blue": "/countries_boundaries/AGO_blue.png",
    "Angola_blue": "/countries_boundaries/Angola_blue.png",
    "AND": "/countries_boundaries/AND.png",
    "Andorra": "/countries_boundaries/Andorra.png",
    "AND_white": "/countries_boundaries/AND_white.png",
    "Andorra_white": "/countries_boundaries/Andorra_white.png",
    "AND_blue": "/countries_boundaries/AND_blue.png",
    "Andorra_blue": "/countries_boundaries/Andorra_blue.png",
    "DZA": "/countries_boundaries/DZA.png",
    "Algeria": "/countries_boundaries/Algeria.png",
    "DZA_white": "/countries_boundaries/DZA_white.png",
    "Algeria_white": "/countries_boundaries/Algeria_white.png",
    "DZA_blue": "/countries_boundaries/DZA_blue.png",
    "Algeria_blue": "/countries_boundaries/Algeria_blue.png",
    "ALB": "/countries_boundaries/ALB.png",
    "Albania": "/countries_boundaries/Albania.png",
    "ALB_white": "/countries_boundaries/ALB_white.png",
    "Albania_white": "/countries_boundaries/Albania_white.png",
    "ALB_blue": "/countries_boundaries/ALB_blue.png",
    "Albania_blue": "/countries_boundaries/Albania_blue.png",
    "AFG": "/countries_boundaries/AFG.png",
    "Afghanistan": "/countries_boundaries/Afghanistan.png",
    "AFG_white": "/countries_boundaries/AFG_white.png",
    "Afghanistan_white": "/countries_boundaries/Afghanistan_white.png",
    "AFG_blue": "/countries_boundaries/AFG_blue.png",
    "Afghanistan_blue": "/countries_boundaries/Afghanistan_blue.png",
    "SIACHE": "/countries_boundaries/SIACHE.png",
    "Siachen Glacier": "/countries_boundaries/Siachen Glacier.png",
    "SIACHE_white": "/countries_boundaries/SIACHE_white.png",
    "Siachen Glacier_white": "/countries_boundaries/Siachen Glacier_white.png",
    "SIACHE_blue": "/countries_boundaries/SIACHE_blue.png",
    "Siachen Glacier_blue": "/countries_boundaries/Siachen Glacier_blue.png",
    "ATA": "/countries_boundaries/ATA.png",
    "Antarctica": "/countries_boundaries/Antarctica.png",
    "ATA_white": "/countries_boundaries/ATA_white.png",
    "Antarctica_white": "/countries_boundaries/Antarctica_white.png",
    "ATA_blue": "/countries_boundaries/ATA_blue.png",
    "Antarctica_blue": "/countries_boundaries/Antarctica_blue.png",
    "SXM": "/countries_boundaries/SXM.png",
    "Sint Maarten": "/countries_boundaries/Sint Maarten.png",
    "SXM_white": "/countries_boundaries/SXM_white.png",
    "Sint Maarten_white": "/countries_boundaries/Sint Maarten_white.png",
    "SXM_blue": "/countries_boundaries/SXM_blue.png",
    "Sint Maarten_blue": "/countries_boundaries/Sint Maarten_blue.png",
    "TUV": "/countries_boundaries/TUV.png",
    "Tuvalu": "/countries_boundaries/Tuvalu.png",
    "TUV_white": "/countries_boundaries/TUV_white.png",
    "Tuvalu_white": "/countries_boundaries/Tuvalu_white.png",
    "TUV_blue": "/countries_boundaries/TUV_blue.png",
    "Tuvalu_blue": "/countries_boundaries/Tuvalu_blue.png"
};

/**
 * Returns the public URL path for a country flag if available.
 * @param {string} country - Full name OR alpha-3 code (e.g., "Pakistan" or "PAK")
 * @returns {string|null} - Public URL path or null
 */
export function getCountryBoundary(country) {
    return countryBoundaryMap[country] || null;
}